import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "icon", "children", "onClick"];
import React from 'react';
import cx from 'classnames';
import styles from './ListButton.m.sass';
var ListButton = function ListButton(_ref) {
  var className = _ref.className,
    icon = _ref.icon,
    children = _ref.children,
    _onClick = _ref.onClick,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("a", _extends({
    className: cx(styles.root, rest.disabled && styles.disabled, className),
    onClick: function onClick(e) {
      return !rest.disabled && _onClick(e);
    }
  }, rest), /*#__PURE__*/React.createElement("span", {
    className: styles.icon
  }, icon), /*#__PURE__*/React.createElement("span", {
    className: styles.buttonItemText
  }, children));
};
export default ListButton;
//# sourceMappingURL=index.js.map
